module.exports = __webpack_public_path__ + "static/media/banner-1.86cc0a47.jpeg";